export default "__VITE_ASSET__MCtwPo1K__"